enum EventPostStatus {
    None,
    Draft,
    Published
}

export default EventPostStatus
